module.exports = __webpack_public_path__ + "static/media/loading.62b171ea.svg";